/*
 * @Author: biu
 * @Date: 2020-04-27 14:58:53
 * @LastEditTime: 2021-07-16 13:29:26
 * @Description: 机器人管理 model
 */

import {
  fetchRobots,
  fetchPoints,
  fetchRobotDetail,
  getPointMaterials,
  deletePointMaterial,
  addPointMaterial,
  getAllDeveloper,
  getAllRobotSalers,
  getRobotSalersByRobotId,
  addRobot,
  updateRobot,
  deleteRobot,
  fetchRobotPeriod,
  setRobotPeriod,
  unbindRobot,
  getRobotsBySerial,
  updateSaler,
  addSaler,
  addSalerList,
  addRobotPeriodNotAllow,
  updateRobotPeriodNotAllowById,
  deleteRobotPeriodNotAllowById,
  getRobotPeriodNotAllowsByDeveloperId,
  queryOpenDoorList,
  addRobotOpenDoor,
  updateRobotOpenDoor,
  deleteRobotOpenDoor,
  getPanelConfig,
  addPanelConfig,
  updatePanelConfig,
  getTemplateList,
  getAwakeningList,
  getCardList,
  getTemiGreet,
  addTemiGreet,
  updateTemiGreet,
  getDistance,
  getAwaitTime,
  getUnbindRobotList
} from '@/services/api'

export default {
  state: {
    data: {
      list: [],
      pagination: {},
    },
    robot: {},
    points: [],
    pointMaterials: [], // 点位素材
    allDeveloper: [],
    periodList: {},
    notAppointList: [], //不可预约时段
    openDoorData: {
      list: [],
      pagination: {},
    },
    panelConfig: {}, //首页配置
    greetConfig: {}, //打招呼配置
    distanceList: [], //打招呼距离
    awaitTimeList: [], //打招呼等待时间
    electricityConfig: {}, //电量配置
    templateList: [],
    awakeningList: [],
    cardList: [],
    unbindRobotList:[], //所有未绑定房间的机器人
  },

  effects: {
    *queryList({ payload = { page: 1, page_size: 10 } }, { call, put }) {
      const res = yield call(fetchRobots, payload)
      const { page, page_size } = payload
      yield put({
        type: 'saveList',
        payload: {
          list: res.results,
          pagination: {
            total: res.count,
            current: page || 1,
            pageSize: page_size || 10,
          },
        },
      })
    },
    *unbind({ payload }, { call, put }) {
      yield call(unbindRobot, payload)
      yield put({
        type: 'getRobotSalersByRobotId',
        payload: payload.robotId,
      })
    },
    *queryRobot({ payload: id }, { call, put }) {
      const res = yield call(fetchRobotDetail, id)
      yield put({
        type: 'saveRobot',
        payload: res,
      })
    },
    *queryPoints({ payload: serial }, { call, put }) {
      const points = yield call(fetchPoints, serial)
      // 根据 sequence 字段排序
      points.forEach(group => {
        group.positionPointDtos.sort((a, b) => a.sequence - b.sequence)
      })
      points.sort((a, b) => a.sequence - b.sequence)

      yield put({
        type: 'savePoints',
        payload: points,
      })
    },
    *getRobotSalersByRobotId({ payload }, { call, put }) {
      const res = yield call(getRobotSalersByRobotId, payload)
      yield put({
        type: 'saveRobotSalers',
        payload: res,
      })
    },
    *getPointMaterials({ payload }, { call, put }) {
      const res = yield call(getPointMaterials, payload)
      yield put({
        type: 'savePointMaterials',
        payload: res,
      })
    },
    *addPointMaterial({ payload }, { call, put }) {
      yield call(addPointMaterial, payload)
      yield put({
        type: 'getPointMaterials',
        payload: payload,
      })
    },
    *queryRobotPoint({ payload }, { call, put }) {
      const res = yield call(getRobotsBySerial, payload)
      yield put({
        type: 'saveCurrRobotPoint',
        payload: res,
      })
    },
    *deletePointMaterial({ payload }, { call, put }) {
      yield call(deletePointMaterial, payload.id)
      yield put({
        type: 'getPointMaterials',
        payload: payload,
      })
    },
    *querySalerList({ payload }, { call, put }) {
      const res = yield call(getAllRobotSalers, payload)
      yield put({
        type: 'saveAllSaler',
        payload: res.results,
      })
    },
    *queryDeveloperList(_, { call, put }) {
      const res = yield call(getAllDeveloper)
      yield put({
        type: 'saveDeveloper',
        payload: res,
      })
    },
    *add({ payload }, { call, put }) {
      yield call(addRobot, payload)
      yield put({
        type: 'queryList',
      })
    },
    *update({ payload }, { call, put }) {
      yield call(updateRobot, payload)
      yield put({
        type: 'queryList',
      })
    },
    *delete({ payload }, { call, put }) {
      yield call(deleteRobot, payload)
      yield put({
        type: 'queryList',
      })
    },
    *queryRobotPeriod({ payload: developerId }, { call, put }) {
      const res = yield call(fetchRobotPeriod, developerId)
      yield put({
        type: 'savePeriod',
        payload: res,
      })
    },
    *setRobotPeriod({ payload }, { call, put }) {
      yield call(setRobotPeriod, payload)
      yield put({
        type: 'queryRobotPeriod',
        payload: payload.developerId,
      })
    },
    *addSaler({ payload }, { call, put }) {
      yield call(addSaler, payload)
      yield put({
        type: 'getRobotSalersByRobotId',
        payload: payload.robotId,
      })
    },
    *addSalerList({ payload }, { call, put }) {
      yield call(addSalerList, payload)
      yield put({
        type: 'getRobotSalersByRobotId',
        payload: payload.robotId,
      })
    },
    *updateSaler({ payload }, { call, put }) {
      yield call(updateSaler, payload)
      yield put({
        type: 'getRobotSalersByRobotId',
        payload: payload.currRobotId,
      })
    },
    *getRobotPeriodNotAllows({ payload }, { call, put }) {
      const res = yield call(getRobotPeriodNotAllowsByDeveloperId, payload)
      yield put({
        type: 'savePeriodNotAllows',
        payload: res,
      })
    },
    *addRobotPeriod({ payload }, { call, put }) {
      yield call(addRobotPeriodNotAllow, payload)
      yield put({
        type: 'getRobotPeriodNotAllows',
        payload: {
          developerId: payload.developerId,
          type: payload.type,
        },
      })
    },
    *updateRobotPeriod({ payload }, { call, put }) {
      yield call(updateRobotPeriodNotAllowById, payload)
      yield put({
        type: 'getRobotPeriodNotAllows',
        payload: {
          developerId: payload.developerId,
          type: payload.type,
        },
      })
    },
    *deleteRobotPeriod({ payload }, { call, put }) {
      yield call(deleteRobotPeriodNotAllowById, payload.id)
      yield put({
        type: 'getRobotPeriodNotAllows',
        payload: {
          developerId: payload.developerId,
          type: payload.type,
        },
      })
    },

    *fetchOpenDoor({ payload = { page: 1, page_size: 10 } }, { call, put }) {
      const res = yield call(queryOpenDoorList, payload)
      const { page, page_size } = payload

      yield put({
        type: 'saveOpenDoor',
        payload: {
          list: res.results,
          pagination: {
            total: res.count,
            pageSize: page_size || 10,
            current: page || 1,
          },
        },
      })
    },

    *removeOpenDoor({ payload }, { call, put }) {
      yield call(deleteRobotOpenDoor, payload.id)
      yield put({
        type: 'fetchOpenDoor',
        payload: {
          robotSerial: payload.robotSerial,
          page: 1,
          page_size: 10,
        },
      })
    },

    *createOpenDoor({ payload }, { call, put }) {
      yield call(addRobotOpenDoor, payload)
      yield put({
        type: 'fetchOpenDoor',
        payload: {
          robotSerial: payload.robotSerial,
          page: 1,
          page_size: 10,
        },
      })
    },

    *updateOpenDoor({ payload }, { call, put }) {
      // const { id, data } = payload
      // yield call(updateRobotOpenDoor, id, data)
      yield call(updateRobotOpenDoor, payload)
      yield put({
        type: 'fetchOpenDoor',
        payload: {
          robotSerial: payload.robotSerial,
          page: 1,
          page_size: 10,
        },
      })
    },

    *getPanelConfigInfo({ payload }, { call, put }) {
      const res = yield call(getPanelConfig, payload)
      yield put({
        type: 'savePanelConfig',
        payload: res,
      })
    },
    *addPanelConfigInfo({ payload }, { call, put }) {
      yield call(addPanelConfig, payload)
      yield put({
        type: 'getPanelConfigInfo',
        payload: payload.serial,
      })
    },
    *updatePanelConfigInfo({ payload }, { call, put }) {
      yield call(updatePanelConfig, payload)
      yield put({
        type: 'getPanelConfigInfo',
        payload: payload.serial,
      })
    },
    *getTemplateListInfo(_, { call, put }) {
      const res = yield call(getTemplateList)
      yield put({
        type: 'saveTemplateList',
        payload: res,
      })
    },
    *getAwakeningListInfo(_, { call, put }) {
      const res = yield call(getAwakeningList)
      yield put({
        type: 'saveAwakeningList',
        payload: res,
      })
    },
    *getCardListInfo(_, { call, put }) {
      const res = yield call(getCardList)
      yield put({
        type: 'saveCardList',
        payload: res,
      })
    },
    *getTemiGreetInfo({ payload }, { call, put }) {
      const res = yield call(getTemiGreet, payload)
      yield put({
        type: 'saveGreetConfig',
        payload: res,
      })
    },
    *addTemiGreetInfo({ payload }, { call, put }) {
      yield call(addTemiGreet, payload)
      yield put({
        type: 'getTemiGreetInfo',
        payload: payload.temiId,
      })
    },
    *updateTemiGreetInfo({ payload }, { call, put }) {
      yield call(updateTemiGreet, payload)
      yield put({
        type: 'getTemiGreetInfo',
        payload: payload.temiId,
      })
    },
    *getDistanceInfo(_, { call, put }) {
      const res = yield call(getDistance)
      yield put({
        type: 'saveDistanceList',
        payload: res,
      })
    },
    *getAwaitTimeInfo(_, { call, put }) {
      const res = yield call(getAwaitTime)
      yield put({
        type: 'saveAwaitTimeList',
        payload: res,
      })
    },
    *queryUnbindRobotList({ payload }, { call, put }) {
      const res = yield call(getUnbindRobotList, payload)
      yield put({
        type: 'saveUnbindRobotList',
        payload: res,
      })
    },
  },

  reducers: {
    saveList(state, { payload }) {
      return { ...state, list: payload }
    },
    saveRobot(state, { payload }) {
      return { ...state, robot: payload }
    },
    savePoints(state, { payload }) {
      return { ...state, points: payload }
    },
    savePointMaterials(state, { payload }) {
      return { ...state, pointMaterials: payload }
    },
    saveDeveloper(state, { payload }) {
      return { ...state, allDeveloper: payload }
    },
    savePeriod(state, { payload }) {
      return { ...state, periodList: payload }
    },
    saveRobotSalers(state, { payload }) {
      return { ...state, robotSalers: payload }
    },
    saveAllSaler(state, { payload }) {
      return { ...state, allSalers: payload }
    },
    saveCurrRobotPoint(state, { payload }) {
      return { ...state, currRobotPoint: payload }
    },
    savePeriodNotAllows(state, { payload }) {
      return { ...state, notAppointList: payload }
    },
    saveOpenDoor(state, { payload }) {
      return {
        ...state,
        openDoorData: payload,
      }
    },
    savePanelConfig(state, { payload }) {
      return { ...state, panelConfig: payload }
    },
    saveTemplateList(state, { payload }) {
      return { ...state, templateList: payload }
    },
    saveAwakeningList(state, { payload }) {
      return { ...state, awakeningList: payload }
    },
    saveCardList(state, { payload }) {
      return { ...state, cardList: payload }
    },
    saveGreetConfig(state, { payload }) {
      return { ...state, greetConfig: payload }
    },
    saveDistanceList(state, { payload }) {
      return { ...state, distanceList: payload }
    },
    saveAwaitTimeList(state, { payload }) {
      return { ...state, awaitTimeList: payload }
    },
    saveUnbindRobotList(state, { payload }) {
      return { ...state, unbindRobotList: payload }
    },
  },
}
